var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGb = function SvgGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A17A7",
    d: "M28 0H0v20h28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m29.282-1.916 1.492 2.21-9.449 6.373H28v6.666h-6.675l9.449 6.373-1.492 2.21-11.95-8.06.001 7.477h-6.666v-7.477l-11.95 8.06-1.49-2.21 9.447-6.373H0V6.667h6.674L-2.774.294l1.492-2.21 11.948 8.06v-7.477h6.667v7.477z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DB1F35",
    strokeLinecap: "round",
    strokeWidth: 0.667,
    d: "M18.668 6.332 31.333-2M20.013 13.697l11.353 7.653M8.006 6.31-3.837-1.67M9.29 13.605-3.837 22.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6273E",
    fillRule: "evenodd",
    d: "M0 12h12v8h4v-8h12V8H16V0h-4v8H0z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gb_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v20H0z"
  })))));
};
export default SvgGb;